import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    selectCollectingData,
    selectShipment,
    selectShipmentUpdatingError,
    selectShipmentUpdatingStatus,
    selectShipmentUploadingStatus,
    setAccordions,
    setCollectingData,
    updateShipment,
} from "../shipmentSlice";
import Receiver from "./Receiver";
import AdditionalData from "./AdditionalData";
import { pushAlert } from "../../alerts/alertSlice";
import { selectCountries } from "../../citySelect/selectCitySlice";
import { validateReceiver } from "../../../validators/validateReceiver";
import { useTranslation } from "react-i18next";
import { getLocationUnitLangPostfix } from "./editShipmentUtils";

const initialState = {
    "sender-city-code": "",
    "sender-town-id": "",
    "sender-address": "",
    "receiver-company": "",
    "receiver-postal-index": "",
    "receiver-name": "",
    "receiver-address": "",
    "receiver-phone-number": "",
    "receiver-email": "",
    "receiver-country": "",
    "receiver-city": "",
    "receiver-area": "",
    "receiver-district": "",
    "receiver-description": "",
    "getting-package-type": "",
    "delivery-speed": "",
    "package-type": "",
    "payment-type": "",
    "declared-price": "",
    "declared-price-currency": "TRY",
    "B2B-order-type": "",
    "B2B-order-number": "",
    countryHasCities: false,
    country: "",
};

const initialErrorsState = {
    "sender-city-code": "",
    "sender-town-id": "",
    "receiver-company": "",
    "receiver-name": "",
    "receiver-address": "",
    "receiver-phone-number": "",
    "receiver-email": "",
    "receiver-country": "",
    "receiver-city": "",
    "receiver-area": "",
    "receiver-district": "",
    "receiver-description": "",
    "getting-package-type": "",
    "delivery-speed": "",
    "package-type": "",
    "payment-type": "",
};

const EditShipment = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    const countries = useSelector(selectCountries);
    const shipment = useSelector(selectShipment);
    const collectingData = useSelector(selectCollectingData);
    //const updatingStatus = useSelector(selectShipmentUpdatingStatus)
    //const updatingError = useSelector(selectShipmentUpdatingError)

    const uploadingStatus = useSelector(selectShipmentUploadingStatus);

    const [shipmentState, setShipmentState] = useState(initialState);
    const [errors, setErrors] = useState(initialErrorsState);

    //on mount
    useEffect(() => {
        if (window.innerWidth >= 768) {
            dispatch(
                setAccordions({
                    receiverOpened: true,
                    additionalOpened: true,
                })
            );
        }
    }, [dispatch]);

    //on shipment change
    useEffect(() => {
        if (!shipment) {
            return;
        }

        setShipmentState({
            "sender-city-code": shipment["sender-city-code"],
            "sender-town-id": +shipment["sender-town-id"],
            "sender-district-id": +shipment["sender-district-id"],
            "sender-address": shipment["sender-address"],
            "receiver-company": shipment["receiver-company"],
            "receiver-postal-index": shipment["receiver-postal-index"],
            "receiver-name": shipment["receiver-name"],
            "receiver-address": shipment["receiver-address"],
            "receiver-phone-number": shipment["receiver-phone-number"],
            "receiver-email": shipment["receiver-email"],
            "receiver-country": shipment["receiver-country-tr"],
            "receiver-city": shipment["receiver-city-tr"],
            "receiver-area": shipment["receiver-area-tr"],
            "receiver-district": shipment["receiver-district-tr"],
            "receiver-description": shipment["description"],
            "getting-package-type": shipment["getting-package-type"],
            "delivery-speed": shipment["delivery-speed"],
            "package-type": shipment["package-type"],
            "payment-type": shipment["payment-type"],
            "declared-price": shipment["declared-price"],
            "declared-price-currency": shipment["declared-price-currency"],
            "B2B-order-type": shipment["B2B-order-type"],
            "B2B-order-number": shipment["B2B-order-number"],
            country: shipment["receiver-country-" + getLocationUnitLangPostfix(i18n.language)],
            countryHasCities: false,
        });
    }, [i18n.language, shipment]);

    //on updating country
    useEffect(() => {
        if (!shipmentState.country) {
            return;
        }
        const country = countries.find(
            (country) => country["ru-name"] === shipmentState.country
        );

        if (country) {
            setShipmentState((prev) => ({
                ...prev,
                countryHasCities: country["has-cities"],
            }));
        }
    }, [countries, i18n.language, shipmentState.country]);

    //on collectingData
    useEffect(() => {
        if (!collectingData) {
            return;
        }
        let errors = validateReceiver(shipmentState);
        if (errors && errors.length > 0) {
            errors.forEach((error) => {
                dispatch(
                    pushAlert({
                        type: "danger",
                        message: t(error),
                        delay: 2000,
                    })
                );
            });
            dispatch(setCollectingData({ value: false }));
            return;
        }
        dispatch(
            updateShipment({ data: shipmentState, shipmentID: shipment.id })
        );
        dispatch(setCollectingData({ value: false }));
    }, [collectingData, dispatch, shipment.id, shipmentState, t]);

    return (
        <>
            {uploadingStatus === "fulfilled" && (
                <div className="w-full flex flex-col md:flex-row items-stretch gap-2 mx-auto mb-10">
                    <AdditionalData
                        shipment={shipment}
                        state={shipmentState}
                        setState={setShipmentState}
                        errors={errors}
                        setErrors={setErrors}
                    />
                    <Receiver
                        state={shipmentState}
                        setState={setShipmentState}
                        errors={errors}
                        setErrors={setErrors}
                    />
                </div>
            )}
        </>
    );
};

export default EditShipment;
